import { ShieldCheck, Clock, HardHat, Users } from "lucide-react";
import { Reveal, SectionHead } from "./shared";

const CARDS = [
  {
    icon: ShieldCheck,
    num: "01",
    title: "Licensed & Insured",
    body: "Full liability coverage and licensing on every job — proof provided before we start, not after you ask.",
  },
  {
    icon: Clock,
    num: "02",
    title: "On-Time, On-Budget",
    body: "A written schedule and an itemized estimate. If a delay or change comes up, you hear it from us first.",
  },
  {
    icon: HardHat,
    num: "03",
    title: "Owner On Every Job",
    body: "You won't get a rotating cast of strangers. The owner is on site, checking the work, every single day.",
  },
  {
    icon: Users,
    num: "04",
    title: "One Crew, Every Trade",
    body: "Framing, roofing, fencing, tree work — the same trusted crew, so nothing falls between contractors' cracks.",
  },
];

export default function WhyTcb() {
  return (
    <section id="why-tcb" data-testid="why-tcb-section" className="py-20 md:py-32 relative overflow-hidden">
      <div className="absolute inset-0 blueprint-grid opacity-60" aria-hidden="true" />
      <div className="relative max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-16">
        <SectionHead
          eyebrow="Why TCB"
          title="Hire the crew, not the middleman."
          sub="Big-box contractors quote low, subcontract high, and disappear. We do the opposite — deliberately."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mt-14">
          {CARDS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08} className="h-full">
              <div
                data-testid={`why-card-${c.num}`}
                className="group h-full bg-ink-card border border-line clip-notch-sm p-8 transition-all duration-300 hover:border-safety/60 hover:-translate-y-1.5"
              >
                <div className="flex items-start justify-between">
                  <span className="w-12 h-12 bg-safety/10 border border-safety/40 flex items-center justify-center clip-notch-sm">
                    <c.icon className="w-6 h-6 text-safety" strokeWidth={2.25} />
                  </span>
                  <span className="font-mono text-xs text-line font-bold group-hover:text-safety transition-colors">{c.num}</span>
                </div>
                <h3 className="font-cond font-bold uppercase text-xl tracking-wide text-bone mt-8">{c.title}</h3>
                <p className="text-steel text-sm leading-relaxed mt-3">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
